module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0008.jpg?v=02b39b3c";